import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { Product } from '~shared/models';
import { APP_PRODUCT_ROUTE } from '~shared/constants';
import { environment } from '~env/environment';
import { ProductCardImageUtil } from '../../utils/product-card-image.util';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services/price-type.service';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { ProductUtil } from '~shared/utils/product.util';
import { ReferencePriceTypes } from '~shared/models/reference-price-types.enum';
import { PDPNavigatorService } from '~shared/modules/pdp-navigator/pdp-navigator.service';
import { PlpVariantRestyleService } from '~shared/services/plp-variant-restyle/plp-variant-restyle.service';
import { EnergyLabelScaleService } from '~shared/modules/product-card/services/energy-label-scale.service';

@Component({
  selector: 'app-search-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit, OnChanges {
  @Input() product: Product;
  @Input() isDesktop: boolean;
  @Input() isProductList = true;
  @Input() isCustomPLPPage = false;
  @Input() isBlackDealsEnabled: boolean;
  @Input() showOnlyImageOnSimilarProductsCarousel = false;
  @Input() isSimilarProductRecommendation: boolean;

  @Output() productClick = new EventEmitter<{ product: Product; priceType: PriceTypes }>();

  referencePriceTypes = ReferencePriceTypes;
  priceType$: Observable<PriceTypes>;
  priceTypes = PriceTypes;

  defaultProductImage = `${environment.cdnBaseUrl()}/images/product-catalog-placeholder.png`;
  appStorefrontProductRoute = `/${APP_PRODUCT_ROUTE}/`;

  isBlackDealProduct: boolean;
  isLimitedStock: boolean;
  shouldApplyZeroVAT: boolean;
  isPLP: boolean;
  isNewPLPVariantRestyle$: Observable<boolean>;
  showEnergyScale: boolean;

  constructor(
    private priceTypeService: PriceTypeService,
    private PDPNavigator: PDPNavigatorService,
    private plpVariantRestyleService: PlpVariantRestyleService,
    private energyLabelScaleService: EnergyLabelScaleService,
  ) {}

  ngOnInit(): void {
    this.showEnergyScale = this.energyLabelScaleService.shouldShowScaleEnergyLabel(this.product?.categories);
    this.priceType$ = this.priceTypeService.priceType$;
    this.priceType$.subscribe((priceType: PriceTypes) => {
      const isUserB2B = priceType === PriceTypes.b2b;
      const isBestOfferCrossBorder = this.product.bestOffer?.origin !== this.product.bestOffer?.destination;
      this.shouldApplyZeroVAT = isBestOfferCrossBorder && isUserB2B;
    });
    this.isNewPLPVariantRestyle$ = this.plpVariantRestyleService.isNewPLPVariantRestyle();
    this.isPLP = this.plpVariantRestyleService.isPLP();
  }

  ngOnChanges(changes: SimpleChanges) {
    // We don't need to do anything unless the product changed, and it's available
    if (!changes['product'] || !changes['product'].currentValue) {
      return;
    }

    this.isBlackDealProduct = ProductUtil.isBlackDealProduct(this.product.tags);
    this.isLimitedStock = !!this.product.bestOffer && ProductUtil.isLimitedStock(this.product.bestOffer.quantity);
  }

  onProductClick(product: Product, priceType: PriceTypes, e: Event): void {
    this.productClick.emit({
      product,
      priceType,
    });
    this.PDPNavigator.navigateToPDP(
      e,
      product.id,
      this.isSimilarProductRecommendation ? '?fromSimilarProducts=1' : '',
    ).subscribe();
  }

  getSourceSet(imageUrl: string): string {
    return ProductCardImageUtil.getSourceSet(imageUrl);
  }
}
